/* eslint-disable */
export default {
  _BPreplay: 'BPreplay',
}